import type { HTMLAttributes, ReactElement } from 'react';
import React, { Children } from 'react';
import clsx from 'clsx';
import './badge-list.scss';

/**
 * A simple wrapper for holding a group / list of badges
 *
 * - horizontal layout with wrap
 * - spacing between badges
 */
export default function BadgeList({
  className,
  children,
  ...htmlAttributes
}: React.PropsWithChildren<{ className?: string } & HTMLAttributes<HTMLElement>>): ReactElement {
  return (
    <ul className={clsx('badge-list reset', className)} {...htmlAttributes}>
      {Children.toArray(children).map((child, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={i}>{child}</li>
      ))}
    </ul>
  );
}
